import { RequestPriority } from '@app/core/interceptors/queue-requests-interceptor/enums/request-priority.enum';

/**
 * Priorities from the highest to the lowest: the order the global http queue (see `http-queue.service.ts`)
 * gives a freed slot within `maxSlots`. Guaranteed slots (`REQUEST_PRIORITY_SLOTS_CONFIG`) go the reverse way.
 * Internal to the queue.
 */
export const REQUEST_PRIORITY_ORDER_CONFIG: RequestPriority[] = [
  RequestPriority.High,
  RequestPriority.Medium,
  RequestPriority.Low,
];
